"use client";

import { Button } from "components";
// not found pageのglobalでの使用にはnext13.4.4が必要
//https://github.com/vercel/next.js/issues/47862
import Header from "components/Header";

export default function Error() {
  return (
    <div className="flex flex-1 flex-col">
      <Header />
      <div className="flex h-[92vh] flex-col items-center justify-center gap-8">
        <img src="/svg/logo.svg" className="h-[109px] w-[370px]" alt="Logo" />
        <p className="text-center">
          <h1 className="text-[32px] font-bold">404 : Not Found</h1>
          <span className="text-base text-gray">指定されたファイル、またはディレクトリは存在しません</span>
        </p>
        <div className="w-[160px]">
          <Button text={"トップページ"} style="outline" href="/" />
        </div>
      </div>
    </div>
  );
}
